export const PERMS = {
  api: {
    message: {
      add: 'api:message:add',
      detail: 'api:message:detail',
      list: 'api:message:list',
      update: 'api:message:update',
    },
  },

  affiliate: {
    detailView: 'affiliate:detail:view',
    list: 'affiliate:list',
    manage: 'affiliate:manage',
    passwordReset: 'affiliate:password:reset',
    statusUpdate: 'affiliate:status:update',

    referral: {
      report: {
        view: 'affiliate:referral:report:view',
      },
      affiliate: {
        report: {
          view: 'affiliate:referral:affiliate:report:view',
        },
      },
      customer: {
        report: {
          view: 'affiliate:referral:customer:report:view',
        },
      },
    },
  },

  referral: {
    customerReport: {
      read: 'referral:customer-report:read',
    },
  },

  charge: {
    assign: 'charge:assign',
    categoryCurrentView: 'charge:category:current:view',

    detail: {
      view: 'charge:detail:view',
      manage: 'charge:detail:manage',
      statusUpdate: 'charge:detail:status:update',
    },

    management: {
      list: 'charge:management:list',
      detail: {
        view: 'charge:management:detail:view',
        list: 'charge:management:detail:list',
      },
    },

    manage: 'charge:manage',
    statusUpdate: 'charge:status:update',

    subCategory: {
      create: 'charge:sub-category:create',
      delete: 'charge:sub-category:delete',
      detailView: 'charge:sub-category:detail:view',
      list: 'charge:sub-category:list',
      statusUpdate: 'charge:sub-category:status:update',
      update: 'charge:sub-category:update',
    },
  },

  club: {
    basic: {
      create: 'club:basic:create',
      delete: 'club:basic:delete',
      editView: 'club:basic:edit:view',
      list: 'club:basic:list',
      statusUpdate: 'club:basic:status:update',
      update: 'club:basic:update',
    },

    premium: {
      approve: 'club:premium:approve',
      create: 'club:premium:create',
      delete: 'club:premium:delete',
      editView: 'club:premium:edit:view',
      list: 'club:premium:list',
      passwordReset: 'club:premium:password:reset',
      reject: 'club:premium:reject',
      statusUpdate: 'club:premium:status:update',
      update: 'club:premium:update',

      admin: {
        plan: {
          details: 'club:premium:admin:plan:details',
        },
      },

      line: {
        details: 'club:premium:get:line:details',
        manage: 'club:premium:manage:line:details',
      },

      subdomain: {
        details: 'club:premium:subdomain:details',
        manage: 'club:premium:manage:subdomain',
      },

      plan: {
        add: 'club:premium:plan:add',
        detail: 'club:premium:plan:detail',
        list: 'club:premium:plan:list',
        update: 'club:premium:plan:update',
        status: 'club:premium:plan:status',
      },

      updateAdminPlanDetails: 'club:premium:update:admin:plan:details',
    },

    switch: 'club:switch',
  },

  commission: {
    category: {
      assign: 'commission:category:assign',
      detailView: 'commission:category:detail:view',
      list: 'commission:category:list',
      manage: 'commission:category:manage',
      statusUpdate: 'commission:category:status:update',
    },

    detail: {
      delete: 'commission:detail:delete',
      list: 'commission:detail:list',
      manage: 'commission:detail:manage',
      view: 'commission:detail:view',
    },

    type: {
      defaultView: 'commission:type:default:view',
    },
  },

  discount: {
    category: {
      list: 'discount:category:list',
      detail: 'discount:category:detail',
      manage: 'discount:category:manage',
      status: 'discount:category:status',
      assignClub: 'discount:category:assign:club',
      detailList: 'discount:category:detail:list',
      detailManage: 'discount:category:detail:manage',
      detailStatus: 'discount:category:detail:status',
    },

    subCategory: {
      detail: 'discount::sub:category:detail',
    },
  },

  common: {
    attributeList: 'common:attribute:list',
    dropdownList: 'common:dropdown:list',
    presignedUrlView: 'common:presigned-url:view',
  },

  conversion: {
    overview: 'conversion:overview',
    store: {
      activity: 'conversion:store:activity',
      list: 'conversion:store:list',
      performance: 'conversion:store:performance',
    },
  },

  customer: {
    detailView: 'customer:detail:view',
    list: 'customer:list',
    manage: 'customer:manage',
    passwordReset: 'customer:password:reset',
    statusUpdate: 'customer:status:update',
  },

  customerPayment: {
    pointWithdrawalAction: {
      manage: 'customer-payment:point-withdrawal-action:manage',
    },
    pointWithdrawal: {
      list: 'customer-payment:point-withdrawal:list',
    },
  },

  customerPoint: {
    setting: {
      list: 'customerpoint:setting:list',
    },
    referral: {
      analytics: 'customerpoint:referral:analytics',
      stage: {
        list: 'customerpoint:referral:stage:list',
        detail: 'customerpoint:referral:stage:detail',
        status: 'customerpoint:referral:stage:status',
        manage: 'customerpoint:referral:stage:manage',
      },
      validity: {
        manage: 'customerpoint:referral:validity:manage',
      },
    },
  },

  email: {
    log: {
      list: 'email:log:list',
    },
  },

  gallery: {
    premium: {
      create: 'gallery:premium:create',
      delete: 'gallery:premium:delete',
      list: 'gallery:premium:list',
      update: 'gallery:premium:update',
    },
  },

  group: {
    assign: {
      subgroup: 'group:assign:subgroup',
    },

    get: {
      detail: 'group:get:detail',

      subgroup: {
        list: 'group:get:subgroup',
        detail: 'group:get:subgroup:detail',
      },
    },

    list: 'group:list',

    manage: {
      group: 'group:manage',
      subgroup: 'group:manage:subgroup',
      subgroupClubStatus: 'group:manage:subgroup:clubstatus',
    },

    summary: 'group:summary',

    update: {
      status: 'group:update:status',

      subgroup: {
        status: 'group:update:subgroup:status',
      },
    },
  },

  host: {
    // ✅ Added
    basic: {
      block: 'host:basic:block',
      create: 'host:basic:create',
      list: 'host:basic:list',
      update: 'host:basic:update',
    },

    detailBasicView: 'host:detail:basic:view', // ✅ Added
    detailPremiumView: 'host:detail:premium:view',

    premium: {
      block: 'host:premium:block',
      create: 'host:premium:create',
      list: 'host:premium:list',
      update: 'host:premium:update',
    },
  },

  location: {
    detailView: 'location:detail:view',
    list: 'location:list',
    update: 'location:update',
    statusUpdate: 'location:status:update',
  },

  plan: {
    detailView: 'plan:detail:view',
    list: 'plan:list',
    manage: 'plan:manage',
    statusUpdate: 'plan:status:update',

    request: {
      approve: 'plan:request:approve',
      list: 'plan:request:list',
      update: 'plan:request:update',
      detail: 'plan:request:detail',
    },

    timeInterval: {
      view: 'plan:time-interval:view',
    },
  },

  point: {
    management: {
      assign: 'point:management:assign',
      create: 'point:management:create',
      delete: 'point:management:delete',
      details: 'point:management:details',
      list: 'point:management:list',
      statusUpdate: 'point:management:status-update',
      update: 'point:management:update',

      slab: {
        create: 'point:management:slab:create',
        delete: 'point:management:slab:delete',
        details: 'point:management:slab:details',
        list: 'point:management:slab',
        statusUpdate: 'point:management:slab:status-update',
        update: 'point:management:slab:update',
      },

      customer: {
        list: 'customerpoint:setting:list',
        detail: 'customerpoint:setting:detail',
        manage: 'customerpoint:setting:manage',
        statusUpdate: 'customerpoint:setting:manage:status',
        referralValidity: 'customerpoint:referral:validity:manage',
      },

      referralStage: {
        list: 'customerpoint:referral:stage:list',
        detail: 'customerpoint:referral:stage:detail',
        manage: 'customerpoint:referral:stage:manage',
        statusUpdate: 'customerpoint:referral:stage:status',
      },
    },
  },

  reservation: {
    ledger: {
      list: 'reservation:ledger:list',
    },
    otp: {
      verify: 'reservation:otp:verify',
    },
  },

  role: {
    agentList: 'role:agent:list',

    assignment: {
      assign: 'role:assignment:assign',
      view: 'role:assignment:view',
    },

    permission: {
      functionList: 'role:permission:function:list',
      list: 'role:permission:list',
      manage: 'role:permission:manage',
    },

    roleList: 'role:role:list',

    type: {
      create: 'role:type:create',
      delete: 'role:type:delete',
      list: 'role:type:list',
    },
  },

  // ✅ Added
  sales: {
    analytics: 'sales:analytics',
    performance: 'sales:performance',
  },

  sms: {
    log: {
      list: 'sms:log:list',
    },
  },

  staff: {
    create: 'staff:create',
    delete: 'staff:delete',
    detailView: 'staff:detail:view',
    list: 'staff:list',
    resetPassword: 'staff:reset-password',
    update: 'staff:update',
    updateStatus: 'staff:update-status',
  },

  static: {
    dataLabel: {
      create: 'static:data-label:create',
      delete: 'static:data-label:delete',
      detail: 'static:data-label:detail',
      list: 'static:data-label:list',
      update: 'static:data-label:update',
    },
    dataType: {
      create: 'static:data-type:create',
      delete: 'static:data-type:delete',
      list: 'static:data-type:list',
      update: 'static:data-type:update',
      viewDetail: 'static:data-type:view:detail',
    },
  },

  storeOwner: {
    list: 'store-owner:list',
  },

  withdrawal: {
    customer: {
      list: 'withdrawal:customer:list',
      view: 'withdrawal:customer:view',
      manage: 'withdrawal:customer:manage',
    },
    setup: {
      detailView: 'withdrawal:setup:detail:view',
      list: 'withdrawal:setup:list',
      manage: 'withdrawal:setup:manage',
    },
  },

  reviewRatings: {
    list: 'review-ratings:list',
    preview: 'review-ratings:preview',
    delete: 'review-ratings:delete',
  },
  recommendation: {
    editorPick: {
      create: 'recommendation:editor-pick:create',
      delete: 'recommendation:editor-pick:delete',
      read: 'recommendation:editor-pick:read',
      update: 'recommendation:editor-pick:update',
    },
    mainPage: {
      group: {
        create: 'recommendation:main-page-group:create',
        delete: 'recommendation:main-page-group:delete',
        get: 'recommendation:main-page-group:get',
        update: 'recommendation:main-page-group:update',
      },
      host: {
        create: 'recommendation:main-page-host:create',
        delete: 'recommendation:main-page-host:delete',
        get: 'recommendation:main-page-host:get',
        update: 'recommendation:main-page-host:update',
      },
      shuffle: {
        get: 'recommendation:main-page-shuffle:get',
        update: 'recommendation:main-page-shuffle:update',
      },
      store: {
        delete: 'recommendation:main-page-store:delete',
        get: 'recommendation:main-page-store:get',
      },
    },
  },
  inquiry: {
    list: 'inquiry:list',
    details: 'inquiry:details',
  },
  promotionalBanner: {
    add: 'promoandoffer:promotional-banner:create',
    delete: 'promoandoffer:promotional-banner:delete',
    list: 'promoandoffer:promotional-banner:get',
    details: 'promoandoffer:promotional-banner:getdetail',
    update: 'promoandoffer:promotional-banner:update',
    status: 'promoandoffer:promotional-banner:updatestatus',
  },
  account: {
    profile: {
      read: 'account:user-profile:view',
      update: 'account:user-profile:update',
    },
  },
  paymentManagement: {
    adminPaymentSetup: {
      manage: 'admin:bank-information:manage',
      view: 'admin:bank-information:view',
    },
    overview: {
      view: 'payment:overview',
      analytics: 'payment:overview:analytics',
      chart: 'payment:overview:chart',
      salesBreakdown: 'payment:sales:breakdown',
    },
    storePaymentLogs: {
      list: 'payment:store:logs',
      details: 'payment:store:logs:details',
    },
    accountInformation: {
      view: 'affiliate-account:information:view',
    },
    customerPaymentLogs: {
      list: 'customer-payment:point-withdrawal:list',
      manage: 'customer-payment:point-withdrawal-action:manage',
    },
  },
} as const;

type FlattenValues<T> = T extends string ? T : T extends Record<string, unknown> ? FlattenValues<T[keyof T]> : never;

export type PermissionKey = FlattenValues<typeof PERMS>;
